exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideshow .slide[data-v-225e50e0]{width:100vw;height:calc(100vh - 64px);display:flex!important;align-items:center;justify-content:center}.slideshow .slide img[data-v-225e50e0]{-o-object-fit:contain;object-fit:contain;margin:0 auto;display:block}", ""]);

// exports
